module.exports = __webpack_public_path__ + "static/media/heroGraphic.b8520ecb.svg";